import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashletComponent} from './dashlet.component';
import {TranslateModule} from "@ngx-translate/core";
import {FileUploadModule} from "primeng/fileupload";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {PrimengSharedModule} from "@hvlng/framework-core/shared";


@NgModule({
    declarations: [
        DashletComponent
    ],
    imports: [
        CommonModule, TranslateModule, FileUploadModule, ConfirmDialogModule, PrimengSharedModule,
    ],
    exports: [
        DashletComponent
    ]
})
export class DashletModule {
}
